import NUSDUKEPHD2019 from './NUS-DUKEPHD-2019';
import NUSICLJDP2019 from './NUS-ICLJDP-2019';
import NUSJHUJDPMUSIC2019 from './NUS-JHUJDP-MUSIC-2019';

export default {
  NUS_DUKEPHD_2019: NUSDUKEPHD2019,
  NUS_ICLJDP_2019: NUSICLJDP2019,
  NUS_JHUJDP_MUSIC_2019: NUSJHUJDPMUSIC2019,
};
